import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";

declare global {
  interface Window { dataLayer: any[];  }
}

@Component({
  selector: "app-modal",
  templateUrl: "./modal.component.html",
  styleUrls: ["./modal.component.css"]
})
export class ModalComponent implements OnInit {
  @Input() title = '';
  @Input() subTitle = '';
  @Input() bodyContent = '';
  @Input() typeModal = '';
  @Input() insuranceSelected;
  @Input() numberOfUsers;
  @Input() onsAdded = [];
  public detailsUsersAndOnds: any;
  public discount = 0;
  public total = 0;
  public _moment: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public activeModal: NgbActiveModal,
    public modalService: NgbModal
  ) {
    moment.locale("es");
    this._moment = moment;
  }

  ngOnInit() {
    if (this.typeModal == 'detailsOfPurchase') {
      let newArr = this.numberOfUsers.map(user => {
        let traveler = [];
        let listOns = this.onsAdded.filter(ons => user == ons.customer);
        traveler.push({
          product: {
            ...this.insuranceSelected,
            totalPrice:
              this.insuranceSelected.totalPrice / this.numberOfUsers.length
          },
          addOns: listOns.map(ons => {
            return {
              ...ons,
              localPrice: ons.localPrice / this.numberOfUsers.length
            };
          }),
          customer: user
        });
        return traveler;
      });

      this.detailsUsersAndOnds = newArr.flat();
      this.discount = this.detailsUsersAndOnds[0].product.discount
        ? this.detailsUsersAndOnds[0].product.totalPrice -
          this.detailsUsersAndOnds[0].product.realPrice
        : 0;

      const total_product = this.detailsUsersAndOnds[0].product
        ? this.detailsUsersAndOnds[0].product.totalPrice *
          this.detailsUsersAndOnds.length
        : 0;

      const list_price_ons = this.onsAdded.map(
        prices =>
          parseFloat(prices.localPrice) / this.detailsUsersAndOnds.length
      );

      const reducer_price_ons = (accumulator, currentValue) =>
        accumulator + currentValue;

      const suma_ons =
        list_price_ons.length > 0
          ? list_price_ons.reduce(reducer_price_ons)
          : 0;

      this.total = total_product + suma_ons;
    }
  }

  addOns() {
    this.activeModal.close({ ...this.insuranceSelected, addOns: true });
    window.dataLayer.push({
      'event': 'insurance_addons',
      'valData': true,
      'insurance_addons': true
    });
  }

  toPayment() {
    window.dataLayer.push({
      'event': 'insurance_addons',
      'valData': false,
      'insurance_addons': false
    });
    if (this.insuranceSelected.productType === 'BUDGET') {
      this.typeModal = 'modalChangeToSuper';
    } else {
      this.buildGeneralDataLayer();
      this.router.navigate(['/m/seguros/step-one']);
    }
  }

  toPaymentEnd() {
    window.dataLayer.push({
      'event': 'up_sale',
      'valData': false,
      'up_sale': false
    });
    this.buildGeneralDataLayer();
    this.router.navigate(['/m/seguros/step-one']);
  }

  updateToSuper(type) {
    sessionStorage.setItem('addOns', JSON.stringify([]));
    this.activeModal.close({ updateTo: type });
    window.dataLayer.push({
      'event': 'up_sale',
      'valData': true,
      'up_sale': true
    });
  }

  buildGeneralDataLayer() {
    let part_date;
    let return_date;
    if (this.router.url.includes('/m/seguros/resultados/destino?dateFrom=')) {
      this.route.queryParams.subscribe(params => {
        if (JSON.stringify(params) !== '{}') {
          part_date = params.dateFrom.replace('/', '-');
          return_date = params.dateTo.replace('/', '-');
        }
      });
    }

    const data = {
      content_type: 'insurance',
      departing_departure_date: part_date.replace('/', '-').split('-').reverse().join('-'),
      returning_departure_date: return_date.replace('/', '-').split('-').reverse().join('-'),
      currency: 'MXN',
      page_category: 'search',
      url_search: this.router.url,
      visitor_type: 'medium-value',
      add_ons: this.onsAdded,
      date_search: moment(new Date()).format('YYYY-MM-DD'),
      time_search: moment(new Date()).format('HH:mm')
    };
    window.dataLayer.push({
      'event': 'insurance_selected_product',
      'valData': data,
      'insurance_selected_product': data
    });
  }
}
